import axios from "axios";
import { createEffect } from "effector";
import React from "react";
import { API_ACCESS_KEY1 } from "../../../common/config/vars";
import { getCustomUserAgent } from "../../../common/customUserAgent";
import { md5Hash, r2json, empty, unpackServerData } from "../../../common/functions";
import { getPhone, getSession, getUuid, getUuidAndSession, removeStorageData, setPhone, setSession, setUuid } from "../../../common/localStorage";

interface IRegResp {
  uuid: string;
  key: string;
}

export interface IRegUserResult {
  loaded: boolean;
  fail: boolean;
  failMsg: string;
}

export function regUserR(phone: string) {
  return fetch("https://izba.kras-abs.ru/api/v3/auth/login", {
    headers: {
      accept: "*/*",
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Custom-User-Agent": getCustomUserAgent(),
      'Access-Control-Allow-Origin': '*',
    },
    referrer: "https://izba.kras-abs.ru/testdima/",
    body: JSON.stringify({ login: phone, password:" " }),
    method: "POST",
    mode: "cors",
    
  })
    .then((resp) => r2json(resp))
    .then((data) => {
      const val = data as IRegResp;
      if (!("key" in val) || !("uuid" in val)) {
        const ret = {
          loaded: true,
          fail: true,
          failMsg: data.message,
        } as IRegUserResult;
        return ret;
      }
      let session = md5Hash(phone + val.key);
      setUuid(val.uuid)
      setSession(session)
      setPhone(phone)
      /*localStorage.setItem("session", session);
      localStorage.setItem("uuid", val.uuid);
      localStorage.setItem("phone", phone);*/
      const ret = {
        loaded: true,
        fail: false,
        failMsg: "",
      } as IRegUserResult;
      return ret;
    });
}

export const getUuidSession = () => {
  const session = getSession()
  const uuid = getUuid()
  const phone = getPhone()
  return { uuid, session, phone };
};

export const remUuidSession = () => {
  //localStorage.removeItem("session");
  //localStorage.removeItem("uuid");
  //localStorage.removeItem("phone");
  //removeStorageData()
};

export const loggedIn = () => {
  const { uuid, session, phone } = getUuidSession();
  // console.log("{ uuid, session, phone }", { uuid, session, phone })
  return !empty(session) || !empty(uuid) || !empty(phone)
};

//--------------------------Регистрация пользователя через платный СМС код-------------------

interface IQuerySendSmsCode {
  setUserSmsId: React.Dispatch<React.SetStateAction<string>>,
  setFailMsg: React.Dispatch<React.SetStateAction<string>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  phone: string,
}

interface IQueryCheckSmsCode {
  setSuccessMsg: React.Dispatch<React.SetStateAction<string>>,
  setFailMsg: React.Dispatch<React.SetStateAction<string>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  phone: string,
  userSmsId: string,
  code: string
}

export const querySendSmsCode = createEffect<IQuerySendSmsCode, void>();
export const queryCheckSmsCode = createEffect<IQueryCheckSmsCode, void>();

querySendSmsCode.use(({setFailMsg, setUserSmsId, setLoading, phone}) =>
  axios.post("https://izba.kras-abs.ru/api/v3/auth/sendCallCode", {
    ...getUuidAndSession(),
    phone : phone,
    key : API_ACCESS_KEY1,
    test:true
    },{
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        "Custom-User-Agent": getCustomUserAgent(),
      }
    }).then((resp) => {
      // let {data, failMsg} = unpackServerData(resp.data, "sendSmsCode.user_sms_id")   
      // console.log(data,failMsg)  
      console.log(resp.data.error) 
      if(resp.data.error && resp.data.error != "") {
        setFailMsg(resp.data.error)
        return
      } 
      setUserSmsId(resp.data.user_sms_id)
    }).catch(e => {
      console.log(e.response.data.error) 
      let msg = e.response.data.error
      // if(e.response && e.response.data) {
      //   let data = unpackServerData(e.response.data)
      //   if(data.failMsg != "") msg = data.failMsg
      // }
      setFailMsg(msg)
    }).finally(() => {
      setLoading(false)
    })
);

queryCheckSmsCode.use(({setFailMsg, setSuccessMsg, setLoading, phone, userSmsId, code}) =>
  axios.post("https://izba.kras-abs.ru/api/v3/auth/checkSmsCode", {
    ...getUuidAndSession(),
    phone : phone,
    userSmsId : userSmsId, 
    code : code,
    key : API_ACCESS_KEY1
    },{
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        "Custom-User-Agent": getCustomUserAgent(),
      }
    }).then((resp) => {
      let {data, failMsg} = unpackServerData(resp.data, "result")
      if(failMsg != "") {
        setFailMsg(failMsg)
        return
      }
      setFailMsg("")
      setSuccessMsg("Успешно")
      setLoading(false)
    }).catch(e => {
      let msg = e.message
      if(e.response && e.response.data) {
        let data = unpackServerData(e.response.data)
        if(data.failMsg != "") msg = data.failMsg
      }
      setFailMsg(msg)
      setSuccessMsg("")
      setLoading(false)
    })
);